export function canUseRateDesk(signedIn: boolean, isPro: boolean): boolean {
  return signedIn && isPro
}
